import { servicePageTitle } from "../helpers";
import { PIERCING_SERVICE_TITLE } from "../constants";

export const createHeadline = ({ headlineTitle }) => servicePageTitle || headlineTitle || PIERCING_SERVICE_TITLE;
